import generateUuid from 'uuid/v4'

const allFunctions = {}
const functionQueue = []
const maxRetries = 4

export const VNEnqueueMessage = (functionToExecute) => {
  let resolver
  let rejector
  let retries = 0
  const functionUuid = generateUuid()
  const functionPromise = new Promise((resolve, reject) => {
    resolver = resolve
    rejector = reject
  })
  functionQueue.push(functionUuid)
  allFunctions[functionUuid] = { functionToExecute, resolver, rejector, retries }

  if (Object.keys(functionQueue).length === 1) {
    exponentialBackoff(functionUuid)
  }

  return functionPromise
}

export const resolveFunctionToExecute = (functionUuid) => {
  const executedFunction = allFunctions[functionUuid]
  executedFunction.resolver('')

  delete allFunctions[functionUuid]
  functionQueue.shift()

  if (functionQueue.length === 0) {
    return
  }

  const nextFunctionToExecute = functionQueue[0]

  exponentialBackoff(nextFunctionToExecute)
}

const executeFunction = (functionUuid) => {
  const functionToExecute = allFunctions[functionUuid].functionToExecute
  functionToExecute(functionUuid)
}

const exponentialBackoff = (functionUuid) => {
  executeFunction(functionUuid)

  setTimeout(() => {
    if (!allFunctions[functionUuid]) return
    if (allFunctions[functionUuid].retries === maxRetries) {
      allFunctions[functionUuid].rejector('Max retries reached')
      functionQueue.shift()
      return
    }

    allFunctions[functionUuid].retries++
    exponentialBackoff(functionUuid)
    executeFunction(functionUuid)
  }, Math.pow(2, allFunctions[functionUuid].retries) * 250)
}